import React, { FC } from 'react'

import BoxedContent from '../../BoxedContent'

import * as SC from './styled'
import { PickCCIProps } from './PickCCI'
import { LoginProps } from './Login'
import { TwoFactorAuthProps } from './TwoFactorAuth'

export type OnboardingFormProps = {
  className?: string
  currentStep: number
  background: string
  pickCCI: PickCCIProps
  login: LoginProps
  twoFactorAuth: TwoFactorAuthProps
}

const OnboardingForm: FC<OnboardingFormProps> = (props) => {
  const { className, currentStep, background, pickCCI, login, twoFactorAuth } = props
  return (
    <SC.Container className={className} $background={background}>
      <BoxedContent>
        {currentStep === 0 && <SC.PickCCI {...pickCCI} />}
        {currentStep === 1 && <SC.Login {...login} />}
        {currentStep === 2 && <SC.TwoFactorAuth {...twoFactorAuth} />}
      </BoxedContent>
    </SC.Container>
  )
}

export default OnboardingForm
